import styled from "styled-components";

export const ErrorSpan = styled.span`
  color: ${(props) => props.theme.colors.errorText};
`;
